export default __webpack_public_path__ + "static/wamo-mic-42ffeb60387b047b6b88d3f1fb069f45.jpg";